import JWT from "@/utils/jwt"
import router from "@/router"
import { login, info, register, logout, loginFacebook, loginGoogle } from './api'
import { SET_AUTH, PURGE_AUTH, SET_ERROR, SET_LOADING, SET_LOGOUT_ACC_FREE, SET_LOGIN_POPUP, SET_TOGGLE_LOGIN_POPUP, SET_TOGGLE_LOGIN_SSO_POPUP } from "./constants"

const authRegister = async ({ commit }, user) => {
  commit(SET_LOADING, true)

  await register(user)
    .then(( response ) => {
      commit(SET_LOADING, false)
      // commit(SET_AUTH, response.data)
      // if (response.data.access_token != null && response.data.access_token != 'undefined') {
      //   JWT.saveToken(response.data.access_token, response.data.refresh_token, response.data.expired_in)
      //   // router.push({ name: 'ebook-list' })
      //
      //   router.push({ name: 'ebook-list' })
      // } else {
      //   commit(SET_ERROR, response.data)
      // }
      router.push({ name: 'ebook' })
    })
    .catch(({ response }) => {
      commit(SET_LOADING, false)
      commit(SET_ERROR, response.data.errors)
    })
}

const authLogin = ({ commit }, payload) => {
  commit(SET_LOADING, true)
  login(payload.username, payload.password).then(( response ) => {
      commit(SET_LOADING, false);
      if(!response) {return false;}
      if (response.userProfile) {
        commit(SET_LOGIN_POPUP, response.userProfile)
        if(response.userProfile.firstLogin) {
          router.push({ name: 'edit-user-profile' });
        } else {
          
          if(payload.router_to !== undefined && payload.router_to !== null) {
            if(payload.router_to =='NOTREDIRECT'){
              payload.callbackFunction()
              return
            }
            router.replace({ name: 'ebook', query: payload.router_to.query });
          } else {
            router.replace({ name: 'ebook', query: {book_active: "0", classes: 1} });
          }
        }
      }
      // return response && response.userProfile ? response.userProfile : null;
    })  
    .finally(() => commit(SET_LOADING, false))
}

const authLoginFacebook = async ({ commit }, data) => {
  commit(SET_LOADING, true)

  await loginFacebook(data)
    .then(( response ) => {
      commit(SET_LOADING, false)
      commit(SET_AUTH, response.data )

      JWT.saveToken(response.data.access_token, response.data.access_token, response.data.expired_in)
      
      router.push({ name: 'ebook-list' })
    })
    .catch(({ response }) => {
      commit(SET_LOADING, false)
      commit(SET_ERROR, response.data)
      router.push({ name: 'home' })
    })
}

const authLoginGoogle = async ({ commit }, token) => {
  commit(SET_LOADING, true)
  await loginGoogle(token)
    .then(( response ) => {
      commit(SET_LOADING, false)
      commit(SET_AUTH, response.data )

      JWT.saveToken(response.data.access_token, response.data.access_token, response.data.expired_in)

      router.push({ name: 'ebook-list' });
    })
    .catch(({ response }) => {
      commit(SET_LOADING, false)
      router.push({ name: 'home' })
    })
}

const authLogout = async ({ commit }) => {
  commit(PURGE_AUTH)
  JWT.destroyToken()
  router.push({ path: '/' })
}

const authInfo = async ({ commit }) => {
  // if (JWT.getAccessToken()) {
  //   await info()
  //   .then(( response ) => {
  //     commit(SET_AUTH, response.data)
  //   })
  //   .catch(({ response }) => {
  //     commit(SET_ERROR, response.data.errors)
  //     commit(PURGE_AUTH)
  //     JWT.destroyToken()
  //     router.push("/")
  //   })
  // } else {
  //   commit(PURGE_AUTH)
  //   JWT.destroyToken()
  // }
}
const fetchUser = ( { commit }, token ) => {
    if(!token) {return false;}
    return getProfile(token).then( res => {
        commit(SET_AUTH, res.data.user );
        JWT.saveAuth(res.data.user);
        return res.data.user;
    }).catch((error) => {
        commit(PURGE_AUTH);
        JWT.destroyToken();
        //router.push("/");
    })
};

const setLoading = ({ commit }, value) => {
  commit(SET_LOADING, value)
}

const setAccFreeLogout = ({ commit }, value) => {
  commit(SET_LOGOUT_ACC_FREE, value)
}

const setLoginPopupData = ({commit}, value) => {
  commit(SET_LOGIN_POPUP, value)
}

const setToggleLoginForm = ({commit}, value) => {
  commit(SET_TOGGLE_LOGIN_POPUP, value)
}


const setToggleLoginSSOForm = ({commit}, value) => {
  commit(SET_TOGGLE_LOGIN_SSO_POPUP, value)
}

export default {
  authLogin,
  authLoginFacebook,
  authLoginGoogle,
  authLogout,
  authRegister,
  authInfo,
  setLoading,
  fetchUser,
  setAccFreeLogout,
  setLoginPopupData,
  setToggleLoginForm,
  setToggleLoginSSOForm
}
